<template>
    <div class="example">
      <div class="text-center">
        <p>{{ $t("registerEvent.mredirect") }}</p>
      </div>
    </div>
  </template>
  
  <script>
import LocalStorageService from '@/services/LocalStorageService';
import RegistrationService from '@/services/RegistrationService';
import EventWaiverService from '@/services/EventWaiverService';
import { mapState } from 'vuex';

export default {
    name: 'ExampleComponent',   
    data() {
        return{
            regObj: {
              brandsE: [],
              classE: [],
              eventSel: {},
              event: [],
              participants: [],
              partsSel: [],
              preferredRow: null,
              promoterSel: {},
              promoters: [],
              spectators: [],
              spectatorsSel: [],
              step: 3,
            },
            eventId : 0,
            eventSel: {},
            promSel: {}
        };      
    }, 
    computed: {
      ...mapState({
        userStore: (state) => state.session.user, 
        defaultPromoterId: state => {
          let defaultPromoters = state.env.get('VUE_APP_DEFAULT_PROMOTER');
          return defaultPromoters.split(',').filter(el => !!el).map(promoter => parseInt(promoter));
        },
      }),
    },
    mounted(){
        if(this.eventId) {
          this.waitForUserAndSetData();
        }
    },
    created(){
        this.eventId = this.$route.params.eventId;
    },
    methods: {
      sayHello() {
        alert('Hello from Vue!');
      },
      async waitForUserAndSetData() {
        if(!this.userStore || !this.userStore.id) {
          if(!this.userStore) {
            await this.$store.dispatch('setUserAction');
          }
          let attempts = 0;
          const maxAttempts = 50; 
          while((!this.userStore || !this.userStore.id) && attempts < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, 100));
            attempts++;
          }
        }
        this.setData();
      },
      async setData(){
        let isPromoter = false;
        if(Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length > 0) {
          await RegistrationService.getPermissionEvent(this.eventId,this.defaultPromoterId).then(resp =>{
            if(resp.data == 1) {
              isPromoter = true;
            }
          })
        } else {
          isPromoter = true;
        }
        //check if es redirect to register event legacy
        const redirectEventLegacy = this.$route.query.redirectEventLegacy && this.$route.query.redirectEventLegacy === '1';
        if ((this.userStore?.id && isPromoter) || redirectEventLegacy) {
          this.regObj.userId = this.userStore.id;
          RegistrationService.getEvent(this.eventId, this.userStore.id).then(_event =>{
            let _eventResp = _event.data.message;
            RegistrationService.getPromoterListDays(30).then(resp =>{
              let _data = resp.data.message;
              this.promSel = _data.filter(x => x.userID == _eventResp.userId);
              this.regObj.promoterSel = this.promSel[0]
              this.regObj.promoters = _data;
              RegistrationService.getEventsByPromoter({"id":_eventResp.userId,"days":500,"limit":50,"user":0,"bGetEventDescription":false}).then(eventResp =>{
                let _resp = eventResp.data.message;
                this.eventSel = _resp.filter(x => x.id == this.eventId)
                this.regObj.eventSel = this.eventSel[0];
                this.regObj.events = _resp;
                EventWaiverService.getRelationshipList({"rolesId":[2,4],"withUserLogin":true,"authorizedUser":true}).then(respRel =>{
                  let _riders = respRel.data.message;
                  _riders.forEach(async x =>
                  {
                    const partFind = this.regObj.participants.find((el) => { return el.userId == x.userId });
                    if (!partFind)
                    {
                      this.regObj.participants.push({
                        selected: false,
                        disabled: false,
                        disabledLimit: false,
                        userId: x.userId,
                        lName: x.lName,
                        fName: x.fName,
                        relationship: x.relationship,
                        status: "",
                        membership: "",
                        membershipColor: false,
                        waivers: "",
                        waiversColor: false,
                        classes: "",
                        classesColor: false,
                        //backg: _backg,
                        emergencyContact: "",
                        relationshipType: x.userRoleCode.replace(',', ', '),
                        eventWaiver: "",
                        eventWaiverCode: "",
                        colorEventWaiver: false,
                        managerAccount: x.managerAccount,
                        birthday: x.birthday
                      });
                    } else
                    {
                      partFind.userId = x.userId;
                      partFind.lName = x.lName;
                      partFind.fName = x.fName;
                      partFind.relationship = x.relationship;
                      partFind.relationshipType = x.userRoleCode.replace(',', ', ');
                      partFind.managerAccount = x.managerAccount;
                      partFind.birthday = x.birthday;
                    }
                  });
                  
                  LocalStorageService.setItem("registration_legacy", this.regObj);
                  this.$router.replace({name: "RegisterEventLegacy"});
                })
                
              })
            }) 
          })
        } else {
          LocalStorageService.removeItem("registration_legacy", this.regObj);
          this.$router.replace({name: "RegisterEventLegacy"});
        }              
      }
    }
  };
  </script>
  